import { APIHelper, AuthUser } from '@archistarai/auth-frontend';

export default {
  namespaced: true,
  state: {
    products: [
      {
        name: 'Single site',
        shortName: 'single',
        isPopular: false,
        guid: 'property-single-site',
        description: 'Purchase an individual site. Useful for part-time developers with only one site in mind. ',
        priceExGst: 295,
        priceIncGst: 324.5,
        suffix: 'each',
        duration_months: null,
        buttonText: 'Purchase site',
        buttonTextIsFreeSiteEligble: 'Unlock site',
        allFeaturesLinkText: 'All features of Starter',
        allFeaturesLinkShowIcon: false,
        mode: 'dark-mode',
        preFeature: null,
        features: [
          'Single site access',
          'Single site planning details',
          'Single site due diligence & feasibility',
          'Single site design generation'
        ],
        isFreeSiteEligble: false,
        numFreeSiteRemaining: 0,
        numFreeSiteTotal: 0
      },
      {
        name: 'Starter',
        shortName: 'starter',
        isPopular: false,
        guid: 'property-starter-monthly',
        description:
          'For the smaller firm looking to grow through rapid assessment of hundreds of sites in an all-in-one platform.',
        priceExGst: 495,
        priceIncGst: 544.5,
        suffix: 'p/m',
        duration_months: 1,
        buttonText: 'Select plan',
        allFeaturesLinkText: 'See all features',
        allFeaturesLinkShowIcon: true,
        mode: 'light-mode',
        preFeature: null,
        features: [
          '1 user seat',
          'Single state coverage',
          'Unlimited planning details',
          'Bulk site assessment',
          'Feasibility calculator',
          'Building design generator',
          'Due diligence report'
        ]
      },
      {
        name: 'Professional',
        shortName: 'professional',
        isPopular: true,
        guid: 'property-professional-monthly',
        description:
          'Perfect for companies that want unlimited access to data, bulk assessment and design tech for a single state.',
        priceExGst: 895,
        priceIncGst: 984.5,
        suffix: 'p/m',
        duration_months: 1,
        buttonText: 'Select plan',
        allFeaturesLinkText: 'See all features',
        allFeaturesLinkShowIcon: true,
        mode: 'light-mode',
        preFeature: 'Everything included in Starter PLUS',
        features: [
          '3 users seats',
          'Single state coverage',
          'Nearmap high-res aerial imagery included',
          'Full construction data to support site finding',
          'Advanced feasibility calculator',
          'Estate master integration',
          'Advanced building design generator with Design editor'
        ]
      },
      {
        name: 'Elite',
        shortName: 'elite',
        isPopular: false,
        guid: 'property-elite-monthly',
        description:
          'For large national enterprises looking to innovate and streamline their long-standing processes with world-first tech.',
        priceExGst: 2495,
        priceIncGst: 2744.5,
        suffix: 'p/m',
        duration_months: 1,
        buttonText: 'Select plan',
        allFeaturesLinkText: 'See all features',
        allFeaturesLinkShowIcon: true,
        mode: 'light-mode',
        preFeature: 'Everything included in Professional PLUS',
        features: [
          'Flexible user seats',
          'National coverage',
          'Priority support',
          'Exclusive workshops',
          'Platform customisation'
        ]
      },
      {
        name: 'Starter',
        shortName: 'starter',
        isPopular: false,
        guid: 'property-starter-annually',
        description:
          'For the smaller firm looking to grow through rapid assessment of hundreds of sites in an all-in-one platform.',
        priceExGst: 495,
        priceIncGst: 544.5,
        suffix: 'p/m',
        duration_months: 12,
        buttonText: 'Select plan',
        allFeaturesLinkText: 'See all features',
        allFeaturesLinkShowIcon: true,
        mode: 'light-mode',
        preFeature: null,
        features: [
          '1 user seat',
          'Single state coverage',
          'Unlimited planning details',
          'Bulk site assessment',
          'Feasibility calculator',
          'Building design generator',
          'Due diligence report'
        ]
      },
      {
        name: 'Professional',
        shortName: 'professional',
        isPopular: true,
        guid: 'property-professional-annually',
        description:
          'Perfect for companies that want unlimited access to data, bulk assessment and design tech for a single state.',
        priceExGst: 895,
        priceIncGst: 984.5,
        suffix: 'p/m',
        duration_months: 12,
        buttonText: 'Select plan',
        allFeaturesLinkText: 'See all features',
        allFeaturesLinkShowIcon: true,
        mode: 'light-mode',
        preFeature: 'Everything included in Starter PLUS',
        features: [
          '3 users seats',
          'Single state coverage',
          'Nearmap high-res aerial imagery included',
          'Full construction data to support site finding',
          'Advanced feasibility calculator',
          'Estate master integration',
          'Advanced building design generator with Design editor'
        ]
      },
      {
        name: 'Elite',
        shortName: 'elite',
        isPopular: false,
        guid: 'property-elite-annually',
        description:
          'For large national enterprises looking to innovate and streamline their long-standing processes with world-first tech.',
        priceExGst: 2495,
        priceIncGst: 2744.5,
        suffix: 'p/m',
        duration_months: 12,
        buttonText: 'Select plan',
        allFeaturesLinkText: 'See all features',
        allFeaturesLinkShowIcon: true,
        mode: 'light-mode',
        preFeature: 'Everything included in Professional PLUS',
        features: [
          'Flexible user seats',
          'National coverage',
          'Priority support',
          'Exclusive workshops',
          'Platform customisation'
        ]
      }
    ]
  },
  getters: {},
  mutations: {
    UPDATE_FREE_ELIGIILITY(state, eligibleFreeSite) {
      state.products.forEach((p, idx) => {
        if (p.guid === 'property-single-site') {
          if (eligibleFreeSite.isFreeSiteEligble) {
            state.products[idx].isFreeSiteEligble = eligibleFreeSite.isFreeSiteEligble;
            state.products[idx].numFreeSiteRemaining = eligibleFreeSite.numFreeSiteRemaining;
            state.products[idx].numFreeSiteTotal = eligibleFreeSite.numFreeSiteTotal;
          }
        }
      });
    }
  },
  actions: {
    async checkForFreeEligbility({ commit }) {
      if (!AuthUser.guid) return;
      try {
        const {
          data: { data }
        } = await APIHelper.AdminAPI.get('/users/user-subscription/eligible-free-site');
        commit('UPDATE_FREE_ELIGIILITY', data);
      } catch (e) {
        throw e;
      }
    }
  }
};
